import React from 'react';
import { Rating as SwipeRating, } from 'react-native-ratings';
export const Rating = () => {
    return React.createElement(SwipeRating, null);
};
Rating.displayName = 'Rating';
